import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M12 8.3l-6 6 1.4 1.4 4.6-4.6 4.6 4.6 1.4-1.4-6-6z" }));
export {
  o as ReactComponent
};
